export const EMPTY_REPORTS_TABLE = 'EMPTY_REPORTS_TABLE';
